import { render } from "./WhatsAppFloat.vue?vue&type=template&id=a68b23d8&scoped=true"
import script from "./WhatsAppFloat.vue?vue&type=script&lang=js"
export * from "./WhatsAppFloat.vue?vue&type=script&lang=js"

import "./WhatsAppFloat.vue?vue&type=style&index=0&id=a68b23d8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a68b23d8"]])

export default __exports__